var React = require('react');

function Negative (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_2530","data-name":"Group 2530","transform":"translate(-1605.963 -646.49)"},[React.createElement("g",{"id":"Group_2518","data-name":"Group 2518","transform":"translate(500.025 -2790.942)","key":0},React.createElement("circle",{"id":"Ellipse_663","data-name":"Ellipse 663","cx":"74.999","cy":"74.999","r":"74.999","transform":"translate(1107.974 3442.237) rotate(-1.058)","fill":"none","stroke":"#252a4f","strokeWidth":"4"})),React.createElement("line",{"id":"Line_168","data-name":"Line 168","x1":"104","y2":"107","transform":"translate(1634.5 673.5)","fill":"none","stroke":"#252a4f","strokeWidth":"4","key":1})]));
}

Negative.defaultProps = {"preserveAspectRatio":"xMidYMid meet","width":"156.814","height":"156.814","viewBox":"0 0 156.814 156.814"};

module.exports = Negative;

Negative.default = Negative;
